import React from 'react';
import {Button, Div, H2, P} from "glamorous";
import data from "../../../data";
import styles from "../../../styles";
import { getRetrievalAppLink } from '../../../misc/utils';

class ThanksMessage extends React.Component {

    state = {
        instoreba: false,
        jwlsLabelRetrivialLink: null
    };

    componentDidMount() {
        var urlParams = window.location.search.substr(1).split('&').reduce(function (q, query) {
            var chunks = query.split('=');
            var key = chunks[0];
            var value = chunks[1];
            return (q[key] = value, q);
        }, {});

        const journey = urlParams.journey;
        if(journey && journey.toLowerCase() === 'instoreba') {
            this.setState({
                instoreba: true
            })
        }
        this.setState({
            jwlsLabelRetrivialLink: getRetrievalAppLink()
        });
    }

    redirectClickHandler() {
        const dest = this.state.jwlsLabelRetrivialLink;
        window.location.assign(dest);
    }

    render() {
        let coCreationButton =
            <Button
                type="button"
                onClick={() => this.redirectClickHandler()}
                css={styles.ctas.outlineMaxWidth}>
                {data.copy("jwlsLabelRetrivialBtn")}
            </Button>;

        if(false === this.state.instoreba) {
            coCreationButton = null;
        }

        return (
            <Div className="container container--generic">
                <Div css={styles.generic}>
                    <Div className="narrowPageContent">
                        <Div textAlign="center" style={{width: '100%', marginTop: '20px'}}>
                            <H2>{data.copy("thankYouMsgH2")}</H2>
                            <P dangerouslySetInnerHTML={{__html: data.copy("thankYouMsgParagraph")}}/>
                            {coCreationButton}
                            <Button type="button" onClick={this.props.clicked}
                                    css={styles.ctas.outlineMaxWidth}>
                                {data.copy("printLabelExitBtn")}
                            </Button>
                        </Div>
                    </Div>
                </Div>
            </Div>
        )
    }
}

export default ThanksMessage;



// WEBPACK FOOTER //
// ./src/components/areas/ThanksMessage/ThanksMessage.js